import { observable } from 'mobx';
import { FIRST } from '../utils/constant';

import panoramicIcon from '../static/tabBar/icon_panoramic@2x.png';
import houseIcon from '../static/tabBar/icon_house@2x.png';
import trafficIcon from '../static/tabBar/icon_traffic@2x.png';
import sellIcon from '../static/tabBar/icon_sell@2x.png';
import copyrightIcon from '../static/tabBar/icon_copyright@2x.png';

import panoramicIconActive from "../static/tabBar/icon_panoramic_active@2x.png";
import houseIconActive from "../static/tabBar/icon_house_active@2x.png";
import trafficIconActive from "../static/tabBar/icon_traffic_active@2x.png";
import sellIconActive from '../static/tabBar/icon_sell_active@2x.png';
import copyrightIconActive from '../static/tabBar/icon_copyright_active@2x.png';

class FooterMobx {
  @observable tabs = [{
      url: '/',
      icon: panoramicIcon,
      activeIcon: panoramicIconActive,
      title: '全景鸟瞰'
    }, {
      url: '/house',
      icon: houseIcon,
      activeIcon: houseIconActive,
      title: '户型鉴赏'
    },{
      url: '/traffic',
      icon: trafficIcon,
      activeIcon: trafficIconActive,
      title: '园林漫游'
    },{
      url: '/sell',
      icon: sellIcon,
      activeIcon: sellIconActive,
      title: '线上售楼'
    },{
      url: '/copyright',
      icon: copyrightIcon,
      activeIcon: copyrightIconActive,
      title: '版权声明'
    }];
  @observable currentItemIndex = FIRST;   // 默认选中的索引
}

export default FooterMobx;